export default function() {
  return {
    items: [],
    lastUpdatedItem: {}
  };
}
